var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useState } from 'react';
import { useFilters } from '../../Hooks/useFilters';
function Header(_a) {
    var title = _a.title, darkHeader = _a.darkHeader, competition = _a.competition, isSidebarWidget = _a.isSidebarWidget;
    var _b = useState(process.env.REACT_APP_SQUARE_LOGO), logoUrl = _b[0], setLogoUrl = _b[1];
    var selectedCompetitionObject = useFilters().selectedCompetitionObject;
    useEffect(function () {
        var url = "";
        if (!isSidebarWidget) {
            url = process.env.REACT_APP_SQUARE_LOGO;
            if (competition) {
                url = selectedCompetitionObject.image;
            }
        }
        else {
            url = darkHeader ? process.env.REACT_APP_WHITE_LOGO : process.env.REACT_APP_BLACK_LOGO;
            if (competition) {
                url = darkHeader ? selectedCompetitionObject === null || selectedCompetitionObject === void 0 ? void 0 : selectedCompetitionObject.imageWhite : selectedCompetitionObject === null || selectedCompetitionObject === void 0 ? void 0 : selectedCompetitionObject.image;
            }
        }
        setLogoUrl(url);
    }, [selectedCompetitionObject, competition, darkHeader, isSidebarWidget]);
    return (_jsxs("div", __assign({ className: "twc-flex twc-row twc-gap-3" }, { children: [_jsx("img", { src: logoUrl, alt: 'logo', width: 50 }), _jsx("div", __assign({ className: 'twc-flex twc-flex-row twc-justify-between twc-items-center twc-w-full' }, { children: _jsx("p", __assign({ className: "".concat((isSidebarWidget && darkHeader) ? " twc-text-white " : " twc-text-black ", " twc-font-semibold text-[14px] ").concat(title ? " twc-border-l " : " twc-border-0 ", " twc-pl-[8px] ").concat(darkHeader ? " twc-border-[#A4A4A4] " : " twc-border-black ") }, { children: title !== null && title !== void 0 ? title : "" })) }))] })));
}
export var MemoizedHeader = memo(Header);
